import {
  LOADED_CONSENT_REQUEST,
  OAUTH_LOGO_UPDATE,
  OAUTH_UPDATE_DEVICE_APPNAME,
  OauthActions,
  OauthState,
  REGULATORY_ACCEPT,
} from './types';

const initialState: OauthState = {
  appLogo: 'fsll',
  client: undefined,
  agreements: undefined,
  requestedScopes: [],
  scopeDetails: undefined,
};

export const oauthReducer = (state = initialState, action: OauthActions): OauthState => {
  switch (action.type) {
    case REGULATORY_ACCEPT:
      return {
        ...state,
        agreements: action.agreements,
      };
    case LOADED_CONSENT_REQUEST:
      return {
        ...state,
        client: action.client,
        agreements: action.agreements,
        requestedScopes: action.requestedScopes,
        scopeDetails: action.scopeDetails,
      };
    case OAUTH_LOGO_UPDATE:
      return {
        ...state,
        appLogo: action.appLogo,
      };
    case OAUTH_UPDATE_DEVICE_APPNAME:
      return {
        ...state,
        appName: action.appName,
      };

    default:
      return state;
  }
};
